import {
  EntityType,
  ErrorComponentConfig,
  LuigiNode,
  NodeContext,
} from '@openmfp/portal-ui-lib';

export const dxpErrorComponentConfig: ErrorComponentConfig = {
  handleEntityRetrievalError(
    entityDefinition,
    errorCode,
    additionalContext,
  ): LuigiNode[] {
    return [
      {
        pathSegment: ':notfound',
        entityType: EntityType.ENTITY_ERROR,
        hideFromNav: true,
        hideSideNav: true,
        viewUrl: `/error-handling#entity_${errorCode}`,
        context: {
          error: {
            code: errorCode,
            entityDefinition,
            additionalContext,
          },
        } as NodeContext,
        isolateView: true,
        loadingIndicator: { enabled: false },
        showBreadcrumbs: false,
        virtualTree: true,
      },
    ];
  },
};
